import { INACTIVITY_TIMEOUT_SEC } from '../constants/timeoutmessage'
import { UPDATE_TIMEOUT_MESSAGE } from '../constants/actions'
import { UI } from '../constants/ui'

let timerUserInactivity: any

export const inactivityMiddleware = (store: any): any => {
  const resetInactivityTimer = () => {
    const updateTimeoutMessage = () => {
      if (
        (store.getState().reservationChange.resId || store.getState().reservation.birthDate) &&
        store.getState().ui.uiState !== UI.CHECKIN_DONE
      ) {
        store.dispatch({ type: UPDATE_TIMEOUT_MESSAGE, payload: true })
      } else {
        store.dispatch({ type: UPDATE_TIMEOUT_MESSAGE, payload: false })
      }
    }
    clearTimeout(timerUserInactivity)
    timerUserInactivity = setTimeout(() => updateTimeoutMessage(), INACTIVITY_TIMEOUT_SEC * 1000)
  }
  document.addEventListener('click', resetInactivityTimer)
  return (next: any): any => (action: any): any => {
    return next(action)
  }
}
